"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionInteractionTrack = exports.CollectionInteractionTrack_CollectionInteractionSource = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
/** The tile source where a collection interaction takes place */
var CollectionInteractionTrack_CollectionInteractionSource;
(function (CollectionInteractionTrack_CollectionInteractionSource) {
    /** UNSET - No source set */
    CollectionInteractionTrack_CollectionInteractionSource[CollectionInteractionTrack_CollectionInteractionSource["UNSET"] = 0] = "UNSET";
    /** TILE - A DPA tile ad */
    CollectionInteractionTrack_CollectionInteractionSource[CollectionInteractionTrack_CollectionInteractionSource["TILE"] = 1] = "TILE";
    /** PILL - The DPA tile ad metadata pill */
    CollectionInteractionTrack_CollectionInteractionSource[CollectionInteractionTrack_CollectionInteractionSource["PILL"] = 2] = "PILL";
    /** GRID - The DPA tile ad grid */
    CollectionInteractionTrack_CollectionInteractionSource[CollectionInteractionTrack_CollectionInteractionSource["GRID"] = 3] = "GRID";
    CollectionInteractionTrack_CollectionInteractionSource[CollectionInteractionTrack_CollectionInteractionSource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CollectionInteractionTrack_CollectionInteractionSource = exports.CollectionInteractionTrack_CollectionInteractionSource || (exports.CollectionInteractionTrack_CollectionInteractionSource = {}));
function createBaseCollectionInteractionTrack() {
    return {
        source: 0,
        dpaProductId: undefined,
        tileIndex: undefined,
        sourceRelativeLocationX: undefined,
        sourceRelativeLocationY: undefined,
        screenRelativeLocationX: undefined,
        screenRelativeLocationY: undefined,
        timestampMillis: undefined,
    };
}
exports.CollectionInteractionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.source !== 0) {
            writer.uint32(8).int32(message.source);
        }
        if (message.dpaProductId !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.dpaProductId }, writer.uint32(18).fork()).ldelim();
        }
        if (message.tileIndex !== undefined) {
            wrappers_1.UInt32Value.encode({ value: message.tileIndex }, writer.uint32(26).fork()).ldelim();
        }
        if (message.sourceRelativeLocationX !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.sourceRelativeLocationX }, writer.uint32(34).fork()).ldelim();
        }
        if (message.sourceRelativeLocationY !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.sourceRelativeLocationY }, writer.uint32(42).fork()).ldelim();
        }
        if (message.screenRelativeLocationX !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.screenRelativeLocationX }, writer.uint32(50).fork()).ldelim();
        }
        if (message.screenRelativeLocationY !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.screenRelativeLocationY }, writer.uint32(58).fork()).ldelim();
        }
        if (message.timestampMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.timestampMillis }, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCollectionInteractionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.source = reader.int32();
                    break;
                case 2:
                    message.dpaProductId = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.tileIndex = wrappers_1.UInt32Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.sourceRelativeLocationX = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.sourceRelativeLocationY = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.screenRelativeLocationX = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.screenRelativeLocationY = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.timestampMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseCollectionInteractionTrack();
        message.source = object.source ?? 0;
        message.dpaProductId = object.dpaProductId ?? undefined;
        message.tileIndex = object.tileIndex ?? undefined;
        message.sourceRelativeLocationX =
            object.sourceRelativeLocationX ?? undefined;
        message.sourceRelativeLocationY =
            object.sourceRelativeLocationY ?? undefined;
        message.screenRelativeLocationX =
            object.screenRelativeLocationX ?? undefined;
        message.screenRelativeLocationY =
            object.screenRelativeLocationY ?? undefined;
        message.timestampMillis = object.timestampMillis ?? undefined;
        return message;
    },
};
//# sourceMappingURL=collection_interaction_track.js.map